module.exports = __webpack_public_path__ + "img/09-restaurace-gusto.3da5265e.jpg";